/**
 * Asetet e mia — çka mban punonjësi nga kompania.
 *
 * Vetëm lexim me qëllim. Dorëzimi dhe kthimi kërkojnë dikë që e pranon pajisjen
 * fizikisht; një buton "kthej" këtu do të premtonte një veprim që sistemi nuk e
 * kryen dot vetëm, dhe do të linte pajisjen të shënuar si të kthyer pa qenë.
 */

import React from 'react';
import { Box } from '@mui/material';
import WorkerAssetsPanel from '../components/assets/WorkerAssetsPanel';

export default function MyAssetsPage() {
  return (
    <Box sx={{ p: { xs: 1.5, sm: 2.5 }, minWidth: 0 }}>
      <WorkerAssetsPanel self title="Asetet e mia" />
    </Box>
  );
}
